export const materialSymbols = {
    apps: 'apps',
    arrowBackIos: 'arrow_back_ios',
    arrowForward: 'arrow_forward',
    arrowForwardIos: 'arrow_forward_ios',
    arrowUpward: 'arrow_upward',
    block: 'block',
    calendar: 'calendar_month',
    cancel: 'cancel',
    check: 'check',
    checkCircle: 'check_circle',
    close: 'close',
    description: 'description',
    doNotDisturb: 'do_not_disturb_on',
    download: 'download',
    draft: 'draft',
    error: 'error',
    folderOpen: 'folder_open',
    gridView: 'grid_view',
    groups: 'groups',
    help: 'help',
    howToVote: 'how_to_vote',
    info: 'info',
    keyboardArrowDown: 'keyboard_arrow_down',
    keyboardArrowUp: 'keyboard_arrow_up',
    keyboardDoubleArrowLeft: 'keyboard_double_arrow_left',
    keyboardDoubleArrowRight: 'keyboard_double_arrow_right',
    listView: 'list',
    logout: 'logout',
    notifications: 'notifications',
    quickReference: 'quick_reference',
    refresh: 'refresh',
    removeCircle: 'remove_circle',
    search: 'search',
    thumbDown: 'thumb_down',
    thumbUp: 'thumb_up',
    upload: 'upload',
    warning: 'warning',
    person: 'person',
    openInNew: 'open_in_new',
    accountCircle: 'account_circle',
};

export type MaterialSymbolKey = keyof typeof materialSymbols;
export type MaterialSymbolValue = (typeof materialSymbols)[keyof typeof materialSymbols];

